module.exports = __webpack_public_path__ + "img/bill-2.d7a02448.png";